export default "__VITE_ASSET__BjKUQ_9t__"